import React from "react";
import { Award } from "lucide-react";
import { useI18n } from "../lib/i18n";

export default function BadgeChip({ badge }) {
  const { t } = useI18n();
  const label = t(`badges.${badge}`) || badge;
  return (
    <div
      data-testid={`badge-chip-${badge}`}
      className="inline-flex items-center gap-2 px-3 py-2 bg-[#3B82F6]/10 border border-[#3B82F6]/40 text-[#3B82F6]"
    >
      <Award className="h-3.5 w-3.5" strokeWidth={1.5} />
      <span className="font-mono text-[11px] uppercase tracking-[0.18em]">{label}</span>
    </div>
  );
}
